import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import SpecificOfferHeroSection from '../components/SpecificOfferHeroSection';

const SpecificOfferPage: React.FC = () => {
    const { t } = useTranslation();

    useEffect(() => {
        window?.scrollTo({ top: 0, behavior: "smooth" })
    }, [])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{t("specificOffer.title")}</title>
                <meta name="description" content={t("specificOffer.title")} />
            </Helmet>
            <SpecificOfferHeroSection />
        </>
    );
};

export default SpecificOfferPage;
